"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fitText = void 0;
var FONT_SIZE_REDUCTION = 0.5;
var attemptFit = function (_a) {
    var e_1, _b;
    var width = _a.width, height = _a.height, text = _a.text, lineHeight = _a.lineHeight, measureTextWidth = _a.measureTextWidth;
    var paragraphs = [];
    var paragraphsText = text.replace(/\n*$/, '').split('\n');
    var _loop_1 = function (paragraphText) {
        var e_2, _c;
        var currentLine = '';
        var words = paragraphText.trim().split(' ');
        var lines = [];
        var addLine = function (line) {
            lines.push({
                text: line,
                width: measureTextWidth(line),
            });
        };
        try {
            for (var words_1 = (e_2 = void 0, __values(words)), words_1_1 = words_1.next(); !words_1_1.done; words_1_1 = words_1.next()) {
                var word = words_1_1.value;
                if (measureTextWidth(currentLine + ' ' + word) > width) {
                    if (currentLine.length === 0) {
                        return { value: null };
                    }
                    addLine(currentLine);
                    currentLine = word;
                    if (measureTextWidth(word) > width) {
                        return { value: null };
                    }
                }
                else {
                    currentLine += (currentLine ? ' ' : '') + word;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (words_1_1 && !words_1_1.done && (_c = words_1.return)) _c.call(words_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        addLine(currentLine);
        paragraphs.push(lines);
    };
    try {
        for (var paragraphsText_1 = __values(paragraphsText), paragraphsText_1_1 = paragraphsText_1.next(); !paragraphsText_1_1.done; paragraphsText_1_1 = paragraphsText_1.next()) {
            var paragraphText = paragraphsText_1_1.value;
            var state_1 = _loop_1(paragraphText);
            if (typeof state_1 === "object")
                return state_1.value;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (paragraphsText_1_1 && !paragraphsText_1_1.done && (_b = paragraphsText_1.return)) _b.call(paragraphsText_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var lineCount = paragraphs.reduce(function (acc, paragraph) { return acc + paragraph.length; }, 0);
    var textHeight = lineHeight * lineCount;
    if (textHeight < height) {
        return paragraphs;
    }
    return null;
};
var fitText = function (_a) {
    var width = _a.width, height = _a.height, text = _a.text, maxFontSize = _a.maxFontSize, lineSpacing = _a.lineSpacing, measureTextWidth = _a.measureTextWidth, measureTextHeight = _a.measureTextHeight;
    var fontSize = maxFontSize;
    while (fontSize > 0) {
        var lineHeight = measureTextHeight({
            fontSize: fontSize,
            intrinsic: lineSpacing === 0,
        });
        var paragraphs = attemptFit({
            width: width,
            height: height,
            text: text,
            lineHeight: lineHeight,
            measureTextWidth: function (text) { return measureTextWidth({ text: text, fontSize: fontSize }); },
        });
        if (paragraphs) {
            return {
                paragraphs: paragraphs,
                fontSize: fontSize,
                lineHeight: lineHeight,
            };
        }
        fontSize -= FONT_SIZE_REDUCTION;
    }
    return { paragraphs: [], fontSize: 0, lineHeight: 0 };
};
exports.fitText = fitText;
